module.exports = __webpack_public_path__ + "img/gd.8148452b.svg";